import React from 'react';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { FormInput } from 'elements/Inputs/FormInput/';
import { StyledLabel } from 'elements/Label/Label';
import { FormDropdown } from 'elements/Inputs/FormInput/Dropdown/Dropdown';
import { selectMagneticFloatCheckData } from './MagneticFloatCheck.data';
import { StyleMagneticFloatCheckDropdown } from '../FailureModeSection/FailureModeSection.styled';

const MagneticFloatCheckSection = (props) => {
    const { selectedTag, formName, changeHandler, formData, isFormReadOnly, userRole } = props;
    const formDropInput = (field) => field.isDropdown ? (
        <StyleMagneticFloatCheckDropdown>
            <FormDropdown
                id={field.key}
                name={field.key}
                label={field.label}
                value={field.value}
                placeholder={field.placeholder}
                handleChange={changeHandler}
                options={field.options}
                isRequired={field.isRequired}
                width={field.width}
                height={field.height}
                marginLeft={field.marginLeft}
                marginRight={field.marginRight}
                labelWidth={field.labelWidth}
                readOnly={isFormReadOnly}
                direction={field.direction}
                borderTop={field.borderTop}
                inputTextAlign={field.inputTextAlign}
                marginTop={field.marginTop}
            />
        </StyleMagneticFloatCheckDropdown>
    )
        : (
            <FormInput
                id={field.key}
                name={field.key}
                label={field.label}
                value={field.value}
                isLabel={field.isLabel}
                isRequired={field.isRequired}
                handleChange={changeHandler}
                type={field.type}
                width={field.width}
                minWidth={field.minWidth}
                labelWidth={field.labelWidth}
                padding={field.padding}
                marginLeft={field.marginLeft}
                readOnly={isFormReadOnly || field.readOnly}
                maxLength={field.maxLength}
                borderRight={field.borderRight}
                borderBottom={field.borderBottom}
                borderTop={field.borderTop}
                borderLeft={field.borderLeft}
                height={field.height}
                textAlign={field.textAlign}
                fontWeight={field.fontWeight}
                userRole={userRole}
                isCalculated={field.isCalculated}
                isCalculatedNew={field.isCalculatedNew}
                isDisabled={field.isDisabled}
                marginTop={field.marginTop}
            />
        );
    return (
        <div>
            {
                selectMagneticFloatCheckData(selectedTag, formName, formData).rows.map(row => (
                    <Grid item container xs={12} key={row.key} style={{ padding: '0' }}>
                        {row.fields.map(field => (
                            <Grid item xs={field.xs} key={field.key}>
                                {field.isLabel
                                    ? (
                                        <StyledLabel
                                            id={field.key}
                                            label={field.label}
                                            fontWeight={field.fontWeight}
                                            fontSize={field.fontSize}
                                            textAlign={field.textAlign}
                                            labelWidth={field.labelWidth}
                                            padding={field.padding}
                                        >
                                            {field.label}
                                        </StyledLabel>
                                    )
                                    : formDropInput(field)}
                            </Grid>
                        )
                        )}
                    </Grid>
                ))
            }
        </div>
    );
};

const mapStateToProps = ({ Forms, Home }) => ({
    selectedTag: Forms.selectedTag,
    dpsData: Forms.dpsData,
    userRole: Home.userRole
});
const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MagneticFloatCheckSection);

MagneticFloatCheckSection.propTypes = {
    changeHandler: PropTypes.func,
    formData: PropTypes.object,
    formName: PropTypes.string,
    isFormReadOnly: PropTypes.bool,
    selectedTag: PropTypes.object,
    userRole: PropTypes.string,
};
